import React from 'react';
import { Users, Building2, Globe2, CheckCircle } from 'lucide-react';
const stats = [{
  label: 'Students Placed',
  value: '500+',
  icon: Users
}, {
  label: 'Partner Universities',
  value: '50+',
  icon: Building2
}, {
  label: 'Countries',
  value: '15+',
  icon: Globe2
}, {
  label: 'Visa Success Rate',
  value: '98%',
  icon: CheckCircle
}];
export function StatsSection() {
  return <section className="py-16 bg-[#1e3a5f] text-white" data-id="element-108">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-110">
          {stats.map(stat => <div key={stat.label} className="p-4" data-id="element-111">
              <div className="flex justify-center mb-4" data-id="element-112">
                <stat.icon className="h-8 w-8 text-[#f59e0b]" data-id="element-113" />
              </div>
              <div className="text-3xl md:text-4xl font-bold mb-2" data-id="element-114">
                {stat.value}
              </div>
              <div className="text-gray-300 text-sm md:text-base" data-id="element-115">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}